import { uploadQueueDB } from '../db/upload-queue.db';

/**
 * Reset the upload queue - useful for development or fixing stuck uploads
 */
export async function resetUploadQueue() {
  try {
    // Delete all uploads and files
    await uploadQueueDB.uploads.clear();
    await uploadQueueDB.files.clear();
    console.log('Upload queue cleared successfully');
  } catch (error) {
    console.error('Failed to clear upload queue:', error);
  }
}

/**
 * Fix stuck "uploading" status - reset them to "pending" so they can retry
 */
export async function fixStuckUploads() {
  try {
    const stuckUploads = await uploadQueueDB.uploads
      .where('status')
      .equals('uploading')
      .toArray();

    for (const upload of stuckUploads) {
      if (upload.id) {
        await uploadQueueDB.uploads.update(upload.id, {
          status: 'pending',
          retryCount: 0
        });
      }
    }

    console.log(`Fixed ${stuckUploads.length} stuck uploads`);
  } catch (error) {
    console.error('Failed to fix stuck uploads:', error);
  }
}

// Expose to window for easy debugging
if (typeof window !== 'undefined') {
  (window as any).resetUploadQueue = resetUploadQueue;
  (window as any).fixStuckUploads = fixStuckUploads;
}
